import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {setSortKey, resetSortKey} from '../../../actions/filters';
import SortItem from './SortItem/SortItem.jsx';
import PropTypes from 'prop-types';

class Sorting extends React.Component {
  static propTypes = {
    sortKey: PropTypes.string.isRequired,
    sortOrders: PropTypes.object.isRequired,
  };

  componentWillUnmount() {
    this.props.resetSortKey();
  }

  render() {
    return <Container fluid className='mb-3'>
      <Row>
        {this.props.fields.includes('id') &&
        <Col xs={12} md={3} classNama={'text-center'}>
          <SortItem sortKey='id'
                    sortOrders={this.props.sortOrders}
                    title={gettext('Сортировать по дате')}
                    name={gettext('Дата')}
                    isActive={this.props.sortKey === 'id'}
                    onClick={this.props.setSortKey}/>
        </Col>}
        {this.props.fields.includes('title') &&
        <Col xs={12} md={3} classNama={'text-center'}>
          <SortItem sortKey='title'
                    sortOrders={this.props.sortOrders}
                    title={gettext('Сортировать по наименованию')}
                    name={gettext('Наименование')}
                    isActive={this.props.sortKey === 'title'}
                    onClick={this.props.setSortKey}/>
        </Col>}
        {this.props.fields.includes('discount_price_number') &&
        <Col xs={12} md={3} classNama={'text-center'}>
          <SortItem sortKey='discount_price_number'
                    sortOrders={this.props.sortOrders}
                    title={gettext('Сортировать по стоимости')}
                    name={gettext('Стоимость')}
                    isActive={this.props.sortKey === 'discount_price_number'}
                    onClick={this.props.setSortKey}/>
        </Col>}
        {this.props.fields.includes('discount') &&
        <Col xs={12} md={3} classNama={'text-center'}>
          <SortItem sortKey='discount'
                    sortOrders={this.props.sortOrders}
                    title={gettext('Сортировать по размеру скидки')}
                    name={gettext('Скидка')}
                    isActive={this.props.sortKey === 'discount'}
                    onClick={this.props.setSortKey}/>
        </Col>}
        {this.props.fields.includes('price') &&
        <Col xs={12} md={3} classNama={'text-center'}>
          <SortItem sortKey='price'
                    sortOrders={this.props.sortOrders}
                    title={gettext('Сортировать по стоимости')}
                    name={gettext('Стоимость')}
                    isActive={this.props.sortKey === 'price'}
                    onClick={this.props.setSortKey}/>
        </Col>}
      </Row>
    </Container>
  }
};

let mapStateToProps = (state) => {
  return {
    sortKey: state.filters.sortKey,
    sortOrders: state.filters.sortOrders,
  }
};

export default compose(connect(mapStateToProps, { setSortKey, resetSortKey }))(Sorting)

